import { useMutation } from "react-query";
import { QueryKeys } from "../queryKeys";
import { axiosInstance } from "../../config/axios";

const importEneryaReconciliationFile = async (file: FormData) => {
  const response = await axiosInstance.post(
    "EneryaReconciliation/ImportFile",
    file,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export function useImportEneryaReconciliation() {
  return useMutation<any, Error, FormData>(
    QueryKeys.ImportEneryaReconciliation,
    (file) => importEneryaReconciliationFile(file)
  );
}